import { lazy } from "react";
import type { WidgetDefinition } from "../types";

export interface AuroraConfig {
  showChart: boolean;
}

const AuroraView = lazy(() => import("./AuroraView"));

export const auroraWidget: WidgetDefinition<AuroraConfig> = {
  type: "aurora",
  version: 1,
  name: "Aurora & space weather",
  description: "NOAA’s planetary Kp index and 3-day forecast, with a plain-language aurora outlook for your latitude.",
  icon: "wind",
  category: "weather",
  defaultSize: { w: 4, h: 4 },
  minSize: { w: 2, h: 2 },
  stackHeight: 360,
  defaults: { showChart: true },
  settings: [{ key: "showChart", label: "Show Kp chart", type: "toggle" }],
  provider: "noaa-swpc",
  capabilities: { requiresLocation: true },
  supportsFullscreen: true,
  Component: AuroraView,
};
